<template>
	<div class="message-list--employment-info">
		<div class="message-list--employment-info-jon">
			<Jon white/>
		</div>
		<div class="message-list--employment-info-content">
			<div class="message-list--employment-info-title">{{ title }}</div>
			<div class="message-list--employment-info-subtitle">
				Jetzt müsst ihr euch nur noch wegen den Formalitäten kurzschließen!
			</div>
			<div class="message-list--employment-info-box">
				<template v-if="isInitiatorCustomer && message.disclosedData">
					<div>{{ message.disclosedData.nameWithSalutation }}</div>
					<div v-if="message.disclosedData.phone">{{ message.disclosedData.phone.formatted }}</div>
					<div v-if="message.disclosedData.email">
						<a :href="'mailto:' + message.disclosedData.email">{{ message.disclosedData.email }}</a>
					</div>
				</template>
				<template v-else-if="message.customer">
					<div>{{ message.customer.nameWithSalutation }}</div>
					<div v-if="message.customer.phone">{{ message.customer.phone.formatted }}</div>
					<div v-if="message.customer.email">
						<a :href="'mailto:' + message.customer.email">{{ message.customer.email }}</a>
					</div>
					<div>{{ message.customer.companyName }}</div>
				</template>
			</div>
		</div>
	</div>
</template>

<script>
import {INITIATOR_CUSTOMER} from "@/store/communication/conversation/messages";
import Jon from "@/vue/common/image/Jon.vue";

export default {
	components: {Jon},

	props: {
		message: {
			type: Object,
			required: true
		},
		initiator: {
			type: String,
			required: true
		}
	},

	computed: {
		isInitiatorCustomer ()
		{
			return this.initiator === INITIATOR_CUSTOMER;
		},
		title ()
		{
			if (this.isInitiatorCustomer)
			{
				return this.message.disclosedData
					? 'Yeah, ' + this.message.disclosedData.name  + ' hat zugesagt!'
					: 'Yeah, die Person hat zugesagt!'
			}

			return 'Yeah, du hast den Job!';
		}
	}
}
</script>
